export default {
    params: ['min'],
    validate: (value, { min }) => {
        if (min && Number(value) < Number(min)) {
            return `The {_field_} field must be $${Number(min).toLocaleString('en-US')} or more`;
        }
        return true;
    }
};